import { InteractionRegistry } from "../InteractionRegistry";
import { lookInteraction } from "./look";
import { inspectInteraction } from "./inspect";
import { takeInteraction } from "./take";
import { dropInteraction } from "./drop";
import { placeInteraction } from "./place";
import { openInteraction } from "./open";
import { wearInteraction } from "./wear";
import { wearFromSceneInteraction } from "./wear-from-scene";
import { removeInteraction } from "./remove";
import { examineInteraction } from "./examine";
import { combineInteraction } from "./combine";
import { rubInteraction } from "./rub";
import { navigateInteraction } from "./navigate";

export function createBuiltinInteractionRegistry(): InteractionRegistry {
  const registry = new InteractionRegistry();
  for (const interaction of [
    lookInteraction,
    inspectInteraction,
    takeInteraction,
    dropInteraction,
    placeInteraction,
    openInteraction,
    wearInteraction,
    wearFromSceneInteraction,
    removeInteraction,
    examineInteraction,
    combineInteraction,
    rubInteraction,
    navigateInteraction,
  ]) {
    registry.register(interaction);
  }
  return registry;
}
